export class TrixPasting {
  constructor(event) {
    this.editor = event.target.editor;
    this.trixElement = this.editor.element;
  }

  init() {
    this.trixElement.addEventListener("trix-before-paste", this.onBeforePaste.bind(this));
    this.trixElement.addEventListener("trix-attachment-add", this.onAttachmentAdd.bind(this));
  }

  onAttachmentAdd(e) {
    var attachment = e.attachment;

    if (!this.isPastedImage(attachment)) return;

    if (this.isDataURI(attachment.getURL())) {
      var source = 'data-uri';
    } else if (this.isRemote(attachment.getURL())) {
      var source = 'remote';
    } else {
      return; // Skip attachments copied and pasted within the same site
    }

    this.updateAttachment(attachment, source);
  }

  onBeforePaste(e) {
    var dataURI = this.extractRawDataURI(e.paste);

    if (dataURI) {
      e.paste.hasOwnProperty('html') ? e.paste.html = '' : e.paste.string = '';
      this.createAttachment(dataURI, 'data-uri', this.editor.getSelectedRange());
    }
  }

  isPastedImage(attachment) {
    var contentType = attachment.getContentType();
    var url = attachment.getURL();

    // Pasted attachments already have Trix attributes while new attachments don't
    // so we use that to identify them
    return url && contentType && (contentType.startsWith('image') || url.startsWith('data:image'));
  }

  isDataURI(uri) {
    return uri.startsWith('data:image');
  }

  isRemote(uri) {
    return !uri.startsWith(window.location.origin);
  }

  updateAttachment(attachment, source) {
    return new Promise(async (resolve) => {
      var data = await this.requestAttachment(attachment.getURL(), source);

      if (data.status === 'ok') {
        attachment.setAttributes({
          contentType: data.content_type,
          sgid: data.sgid,
          url: data.url
        });
      } else {
        if (data.message) UIHelpers.displayFlashError(data.message);
        var attachmentRange = this.editor.getDocument().getRangeOfAttachment(attachment);
        this.editor.setSelectedRange(attachmentRange);
        this.editor.deleteInDirection('backward');
      }
      resolve();
    });
  }

  extractRawDataURI(trixPaste) {
    if (trixPaste.hasOwnProperty('string')) {
      let matchData = trixPaste.string.match(/^data:image\/.*?$/);

      return matchData ? matchData[0] : null;
    }
  }

  createAttachment(url, source, range) {
    return new Promise(async (resolve) => {
      var data = await this.requestAttachment(url, source);

      if (data.status === 'ok') {
        var attachment = new Trix.default.Attachment({
          contentType: data.content_type,
          sgid: data.sgid,
          url: data.url
        });

        this.editor.setSelectedRange(range);
        this.editor.insertAttachment(attachment);
      } else if (data.message) {
        UIHelpers.displayFlashError(data.message);
      }

      resolve();
    });
  }

  requestAttachment(url, source) {
    let formData = new FormData();
    let csrfParam = document.querySelector('meta[name="csrf-param"]');
    let csrfValue = document.querySelector('meta[name="csrf-token"]');
    formData.append(csrfParam.content, csrfValue.content);
    formData.append('url', url);
    formData.append('source', source);

    return fetch(`${window.location.origin}/pasted_attachments`, { body: formData, method: 'POST' })
      .then((response) => { return response.json() })
      .then((data) => { return data });
  }
}
